export const getFormattedSeminarDateEvent = (
  startDate: string,
  endDate: string,
) => {
  if (!startDate && !endDate) {
    return undefined;
  }

  const startDateObj = startDate ? new Date(startDate) : undefined;
  const endDateObj = endDate ? new Date(endDate) : undefined;

  return {
    start: {
      day: startDateObj?.getDate(),
      month: startDateObj ? startDateObj.getMonth() + 1 : undefined,
      monthText: startDateObj
        ? startDateObj.toLocaleString('de-DE', { month: 'long' })
        : undefined,
      year: startDateObj ? startDateObj?.getFullYear() : undefined,
      hour: startDateObj ? startDateObj?.getHours() : undefined,
      minute: startDateObj
        ? String(startDateObj.getMinutes()).padStart(2, '0')
        : undefined,
    },
    end: {
      day: endDateObj?.getDate(),
      month: endDateObj ? endDateObj.getMonth() + 1 : undefined,
      monthText: endDateObj
        ? endDateObj.toLocaleString('de-DE', { month: 'long' })
        : undefined,
      year: endDateObj ? endDateObj?.getFullYear() : undefined,
      hour: endDateObj ? endDateObj?.getHours() : undefined,
      minute: endDateObj
        ? String(endDateObj.getMinutes()).padStart(2, '0')
        : undefined,
    },
  };
};

export const getFormattedSeminarDate = (
  startDate: string,
  endDate: string,
  dateText?: string | null,
) => {
  if (dateText) {
    return dateText;
  }

  if (!startDate && !endDate) {
    return undefined;
  }

  const startDateObj = startDate ? new Date(startDate) : undefined;
  const endDateObj = endDate ? new Date(endDate) : undefined;
  const formattedStartDateString = `${startDateObj?.toLocaleDateString(
    'de-DE',
    {
      dateStyle: 'long',
    },
  )}`;
  const formattedStartTimeString = `${startDateObj?.toLocaleTimeString(
    'de-DE',
    {
      timeStyle: 'short',
    },
  )}`;
  const formattedEndDateString = `${endDateObj?.toLocaleDateString('de-DE', {
    dateStyle: 'long',
  })}`;
  const formattedEndTimeString = `${endDateObj?.toLocaleTimeString('de-DE', {
    timeStyle: 'short',
  })}`;
  if (
    formattedStartDateString === formattedEndDateString &&
    formattedStartDateString
  ) {
    return `${formattedStartDateString} (${formattedStartTimeString} - ${formattedEndTimeString} Uhr)`;
  }
  return `${startDate ? `${formattedStartDateString} (${formattedStartTimeString} Uhr)` : ''}${endDate ? ` - ${formattedEndDateString} (${formattedEndTimeString} Uhr)` : ''}`;
};

export const getFormattedDate = (date: string): string => {
  const dateObj = date ? new Date(date) : undefined;

  if (dateObj) {
    const formattedDateString = `${dateObj?.toLocaleDateString('de-DE', {
      dateStyle: 'long',
    })}`;
    const formattedTimeString = `${dateObj?.toLocaleTimeString('de-DE', {
      timeStyle: 'short',
    })}`;

    return `${formattedDateString} (${formattedTimeString} Uhr)`;
  }

  return '';
};

export const cloneAndRemoveTypename = <T>(obj: T): T => {
  return JSON.parse(
    JSON.stringify(obj, (k, v) => (k === '__typename' ? undefined : v)),
  );
};

export const truncateStringAtWhitespace = (
  str: string,
  maxLen: number,
  separator = ' ',
) => {
  if (str.length <= maxLen) return str;
  return str.substring(0, str.lastIndexOf(separator, maxLen)) + '...';
};
